import m from "../../geodata/es2015/chadLow";
window.am4geodata_chadLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/chadLow.js
// module id = null
// module chunks = 